export default __webpack_public_path__ + "static/media/NCDC.f0c6adb2.png";